export default "__VITE_ASSET__BJ$JnzkC__"